import { Component, OnInit, inject, input, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faPenToSquare } from '@fortawesome/pro-solid-svg-icons';
import { defaultPalette } from '../../../../core/constants-repository/color-palette.constants';
import { UserOperation } from '../../../../core/enums/user-operation';
import { TagModel } from '../../../../core/models/tag/tag.model';
import { ShiveDialogService } from '../../../../core/services/controls/shive-dialog.service';
import { FormControlNameRecord } from '../../../data-types/form-types';

@Component({
  selector: 'app-shive-taglist-dialog',
  templateUrl: './shive-taglist-dialog.component.html',
  standalone: false,
})
export class ShiveTaglistDialogComponent implements OnInit {
  readonly tag = input.required<TagModel>();
  readonly tagForm = signal<FormGroup>(null);

  public readonly faPenToSquare = faPenToSquare;
  public readonly formControlNames: FormControlNameRecord = {
    Name: 'name',
    Color: 'color',
  };
  public readonly defaultPalette = defaultPalette;

  // DI
  private readonly formBuilder = inject(FormBuilder);
  private readonly shiveDialogService = inject(ShiveDialogService);

  ngOnInit(): void {
    this.tagForm.set(
      this.formBuilder.group({
        [this.formControlNames.Name]: [this.tag().name, Validators.required],
        [this.formControlNames.Color]: [this.tag().color, Validators.required],
      }),
    );
  }

  public close() {
    this.shiveDialogService.close(UserOperation.Cancel);
  }

  public submit() {
    const updatedTag = new TagModel();
    updatedTag.id = this.tag().id;
    updatedTag.name = this.tagForm().controls[this.formControlNames.Name].value;
    updatedTag.color = this.tagForm().controls[this.formControlNames.Color].value;

    this.shiveDialogService.close(updatedTag);
  }
}
